<template>
  <v-snackbar
    :timeout="timeout"
    v-model="activeSnackbar"
    color="#fff"
    location="top right"
    content-class="content-snackbar"
    multi-line
  >
    <div class="d-flex position-relative h-100">
      <div
        style="width: 50px; max-width: 50px; min-width: 50px; flex-grow: 1"
        :style="{ backgroundColor: accentColor }"
        class="d-flex flex-column justify-center pa-4 position-relative"
      >
        <v-icon class="position-absolute" color="white" :icon="displayIcon"></v-icon>
      </div>
      <div class="pa-4 pr-8 message-container">
        <h4 v-if="color === 'error'" class="error-heading fs-18 font-weight-light-bold">
          An error has occurred.
        </h4>
        <em class="preserve-linebreaks fs-16">
          {{ message }}
        </em>
      </div>
      <v-icon
        role="button"
        icon="mdi-close"
        variant="text"
        class="position-absolute"
        style="top: 12px; right: 12px; padding: 0"
        size="small"
        @click.stop="snackbarStore.resetSnackbar()"
      >
      </v-icon>
    </div>
  </v-snackbar>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useSnackbarStore } from '@/stores/snackbarInfo';
import { ref, watch } from 'vue';
import { computed } from 'vue';

const snackbarStore = useSnackbarStore();
const { color, message, timeout, active } = storeToRefs(useSnackbarStore());

const displayIcon = computed(() => {
  if (color.value === 'success') {
    return 'mdi-check';
  } else if (color.value === 'error') {
    return 'mdi-close';
  } else if (color.value === 'info') {
    return 'mdi-information-outline';
  } else {
    return '';
  }
});

const accentColor = computed(() => {
  if (color.value === 'success') {
    return '#4CB848';
  } else if (color.value === 'error') {
    return '#DC2626';
  } else if (color.value === 'info') {
    return '#0E6CB3';
  } else {
    return '';
  }
});

const activeSnackbar = ref(false);

watch(active, (value) => {
  activeSnackbar.value = value;
});

watch(activeSnackbar, (value) => {
  if (!value) {
    snackbarStore.resetSnackbar();
  }
});
</script>

<style scoped>
:deep(.v-snackbar__content) {
  padding: 0;
  width: auto;
  max-width: calc(100vw - 24px);
}

@media (min-width: 768px) {
  :deep(.v-snackbar__content) {
    max-width: 750px;
  }
}

:deep(.content-snackbar) {
  min-height: fit-content !important;
}

.message-container {
  background-color: #fff;
  word-wrap: break-word;
  overflow-wrap: break-word;
  flex: 1;
}

.preserve-linebreaks {
  white-space: pre-line;
  margin: 0;
  line-height: 2;
}
.error-heading {
  margin: 0 0 8px 0;
}
</style>
